// extracted by mini-css-extract-plugin
export default {"base":"PersonalData_base__B86C-","content":"PersonalData_content__jHb07","subTitle":"PersonalData_subTitle__ILHFI","text":"PersonalData_text__Fn6sf"};